export const getTrackData = async (
  taskId: string,
  fromDaysBefore = 1,
  filter: any,
  limit = 1000
): Promise<any> => {
  const win = window as any
  const api = win.api

  const companyId = api.globals.getCompanyId()

  if (!filter) {
    const start = new Date()
    start.setHours(start.getHours() - 24 * fromDaysBefore)
    const startDt = start.getTime()

    filter = {
      createdAt: {
        start: startDt,
        end: Date.now()
      }
    }
  }

  return await api.UserEventsClient.getDataLimited(
    companyId,
    limit,
    filter,
    taskId
  )
}
